/** @file gizmoRadius: the gizmo's radius in CSS pixels for a tool and a viewport height (a big trackball). */
import type { Tool } from '../../state/editorTypes';
import { GIZMO_METRICS as M } from './gizmoMetrics';

/** `clamp(0.18 x viewCssHeight, 72, 180)` for the rotate trackball; move and scale handles take 0.75 of it. */
export function gizmoRadius(tool: Tool, viewCssHeight: number): number {
  const r = Math.min(M.radiusMax, Math.max(M.radiusMin, M.viewShare * viewCssHeight));
  return tool === 'rotate' ? r : r * M.toolScale;
}
